<svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6.00015 7.58594L12.0002 13.5859L18.0002 7.58594L19.4144 9.00015L12.0002 16.4144L4.58594 9.00015L6.00015 7.58594Z"
    fill="currentColor"
  />
</svg>
